import { useState } from 'react'
import BottomSheetContent from '../../../components/BottomSheetComponents/BottomSheetContent'

const INFINITE_STAR_LOGO = '/images/infinite/infinite_bottom_sheet_logo.png'

type InfiniteRequestCallbackBottomSheetProps = {
  onDismiss: () => void
  onRequestCallback: () => void
}

export function InfiniteRequestCallbackBottomSheet({
  onDismiss,
  onRequestCallback
}: InfiniteRequestCallbackBottomSheetProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  return (
    <BottomSheetContent
      onDismiss={onDismiss}
      bottomSheetHeadClassName='!pt-6'
      bottomSheetBodyClassName='!px-6 !pt-0 !pb-2'
      bottomSheetCtas={
        <div className='flex w-full flex-col gap-3'>
          <div
            className='flex h-14 w-full cursor-pointer items-center justify-center rounded-xl bg-[#232323] text-base font-medium text-white'
            onClick={() => {
              if (isSubmitting) {
                return
              }
              setIsSubmitting(true)
              onRequestCallback()
            }}
          >
            Request a callback
          </div>
          <div
            className='flex h-14 w-full cursor-pointer items-center justify-center rounded-xl border border-[#E5E5E5] bg-white text-base font-medium text-[#232323]'
            onClick={onDismiss}
          >
            Maybe Later
          </div>
        </div>
      }
    >
      <div className='flex flex-col items-center text-center'>
        <img src={INFINITE_STAR_LOGO} alt='' className='h-auto w-[134px] object-contain' />
        <h2 className='mt-6 max-w-[300px] font-libre-caslon text-[22px] font-normal leading-[1.2] tracking-[-0.2px] text-[#232323]'>
          Infinite is our highest level of wealth management
        </h2>
        <div className='mt-5 flex max-w-[320px] flex-col gap-4 text-sm font-normal leading-[1.5] text-[#6A6E6E]'>
          <p>
            It&apos;s designed for investors like you, whose portfolio deserves a dedicated team of professionals
            managing it end to end.
          </p>
          <p>The price for Infinite will be AUM-linked and best priced in the market</p>
          <p>
            If you&apos;d like to learn more, we&apos;ll have one of our advisors call you within the next 24 hours.
          </p>
        </div>
      </div>
    </BottomSheetContent>
  )
}
